import { IssuerIntegratorListResponse } from 'src/models/issuerIntegrator.models'

/**
 * Response envelope for `GET /issuers`.
 *
 * The per-issuer shape (`IssuerIntegratorListResponse`) already lives in
 * `src/models/issuerIntegrator.models.ts` and is reused; only this list
 * envelope is new here. It replaces the legacy Redux
 * `GetIssuersSuccessPayload`, deleted with
 * `src/redux/actions/data/issuerIntegrators.actions.ts`.
 */
export interface GetIssuersResponse {
  issuers: IssuerIntegratorListResponse[]
}

/**
 * JPM has no BIN ranges, so JPM-branded surfaces (RegisterAccount,
 * AddressForm, OnboardingStepFour) resolve the issuer integrator with this
 * fixed id instead of the BIN-range lookup. Previously duplicated as a
 * string literal at each call site.
 */
export const JPM_ISSUER_ID = 'ii_cc73a021b368408e9d5f72'
